(function() {
  if (window.SlideshowModuleInitialized) return;
  window.SlideshowModuleInitialized = true;

  function playVideoEl(video) {
    if (!video) return;
    if (video.dataset.src && !video.src) {
      video.src = video.dataset.src;
      video.removeAttribute('data-src');
      video.load();
    }
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {});
    }
  }

  function pauseVideoEl(video) {
    if (!video) return;
    if (!video.paused) {
      video.pause();
    }
  }

  function updateSlideVideos(swiperInstance) {
    if (!swiperInstance || !swiperInstance.slides) return;
    swiperInstance.slides.forEach((slide, idx) => {
      const video = slide.querySelector('video');
      if (!video) return;

      const isActive = slide.classList.contains('swiper-slide-active') || 
                       slide.classList.contains('swiper-slide-duplicate-active') ||
                       idx === swiperInstance.activeIndex;

      if (isActive) {
        playVideoEl(video);
      } else {
        pauseVideoEl(video);
      }
    });
  }

  function initSwipers(defaults = {}, selector = ".swipeslideshow") {
    const swipers = document.querySelectorAll(selector);
    swipers.forEach((swiper) => {
      if (swiper.classList.contains('swiper-initialized')) return;

      let optionsData = {};
      if (swiper.dataset.sectionSetting) {
        try {
          const sectionSetting = JSON.parse(swiper.dataset.sectionSetting);
          const space = 24;
          const spacemobile = 8;
          
          optionsData = {
            slidesPerView: 1,
            spaceBetween: space,
            updateOnWindowResize: true,
            pagination: { clickable: true },
          };

          if (sectionSetting.content_type) {
            optionsData.breakpoints = {
              0: { spaceBetween: spacemobile, centeredSlides: true, slidesPerView: 1.08 },
              768: { slidesPerView: 1.2, centeredSlides: true, spaceBetween: space },
              992: { slidesPerView: 1.9, centeredSlides: true, spaceBetween: space },
            };
          } else {
            optionsData.breakpoints = {
              0: { spaceBetween: spacemobile, centeredSlides: false, slidesPerView: 1 },
              768: { slidesPerView: 1, centeredSlides: false, spaceBetween: space },
            };
          }

          if (sectionSetting.enable_loop) optionsData.loop = true;
          if (sectionSetting.transition === "tran_slide") optionsData.effect = "slide";
          if (sectionSetting.transition === "tran_card") optionsData.effect = "cards";
          if (sectionSetting.transition === "tran_coverflow") optionsData.effect = "coverflow";

          if (sectionSetting.auto_rotate) {
            optionsData.autoplay = {
              delay: sectionSetting.change_slides_speed * 1000,
              disableOnInteraction: false,
            };
          }

          if (sectionSetting.enable_slide_arrow) {
            optionsData.navigation = {
              nextEl: swiper.querySelector(".swiper-button-next") || ".swiper-button-next",
              prevEl: swiper.querySelector(".swiper-button-prev") || ".swiper-button-prev",
            };
          }

          if (["dots", "line", "counter", "numbers"].includes(sectionSetting.pagination_style)) {
            optionsData.pagination = { 
              el: swiper.querySelector(".swiper-pagination") || ".swiper-pagination",
              clickable: true 
            };

            if (sectionSetting.pagination_style === "line") {
              optionsData.pagination.type = "bullets";
              optionsData.pagination.renderBullet = (index, className) =>
                `<span class="${className}"><i></i><b></b></span>`;
            }

            if (sectionSetting.pagination_style === "counter") {
              optionsData.pagination.type = "fraction";
            }

            if (sectionSetting.pagination_style === "numbers") {
              optionsData.pagination.renderBullet = (index, className) =>
                `<span class="${className}">${index + 1}</span>`;
            }
          }

          optionsData.on = {
            init: function() {
              updateSlideVideos(this);
            },
            slideChange: function() {
              updateSlideVideos(this);
            }
          };

          const options = { ...defaults, ...optionsData };
          if (typeof Swiper !== 'undefined') {
            const swiperInstance = new Swiper(swiper, options);
            setupIntersectionObserver(swiper, swiperInstance);
          }
        } catch (e) {
          console.error('Error parsing section settings JSON:', e);
        }
      }
    });
  }

  function setupIntersectionObserver(swiperEl, swiperInstance) {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          const videos = swiperEl.querySelectorAll('video');
          videos.forEach((v) => pauseVideoEl(v));
        } else {
          if (swiperInstance) {
            updateSlideVideos(swiperInstance);
          }
        }
      });
    }, { threshold: 0.15 });

    observer.observe(swiperEl);
  }

  window.initSwipers = initSwipers;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSwipers());
  } else {
    initSwipers();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initSwipers();
  });
})();
